// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__Wpl3g","label":"SetPasswdForm_label__2nIfc"};